// src/api/ticketLogApi.js
import apiClient from './axios';

const ticketLogApi = {
  getAll: async (page = 1, pageSize = 20, search = '', ticket = '') => {
    const response = await apiClient.get('/ticket-logs/', {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined,
        ticket: ticket || undefined,
      },
    });
    return response.data;
  },
};

export default ticketLogApi;